import React from 'react'
import PropTypes from 'prop-types'

import { arrowHeaderInc } from './Forms/statusForms/image'
const Header = ({onClickBack, title}) => (
  <header className='header'>
    <div className="header-wrap wrap">
      <button className="back-button" onClick={onClickBack} type='button'>
        {arrowHeaderInc}
      </button>
      <span className="title">{title || 'Замовлення картки'}</span>
    </div>
  </header>
)

Header.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  title: PropTypes.string
}

export default Header